import { memo } from "react";
import { Table, Collapse, ScrollArea } from "@mantine/core";
import { v4 as uuidv4 } from "uuid";

type columns = {
  title: string | any;
  centered?: boolean;
  size?: number;
  hidden?: boolean;
};

type data = {
  [key: string]: any;
};

interface TablePros {
  dataSource: { columns: columns[]; data?: data[any] };
  openedRow?: any;
}

const TableComponent = (props: TablePros) => {
  const { dataSource, openedRow } = props;

  return (
    <ScrollArea type="auto">
      <Table verticalSpacing="sm" style={{ minWidth: 600 }}>
        <thead className="bg-[#F8F9FB] font-semibold">
          <tr className="border-b-[1px] border-[#dee2e6]">
            {dataSource.columns.map((column: columns, index: number) => {
              return (
                <th
                  className="p-2"
                  key={uuidv4()}
                  style={{
                    display: column.hidden ? "none" : "",
                    width: `${column.size}` ? `${column.size}px` : "",
                  }}
                >
                  <div className="whitespace-nowrap">
                    <div className={`${column.centered ? "mx-auto" : ""} `}>
                      {column.title}
                    </div>
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="bg-white w-full">
          {dataSource.data.map((item: any, index: number) => (
            <>
              <tr key={uuidv4()}>
                {Object.keys(item)
                  .filter((key) => key !== "collapse")
                  .map((key) => (
                    <td key={key}>{item[key] || ""}</td>
                  ))}
              </tr>
              {item.collapse && openedRow === index && (
                <tr>
                  <td
                    colSpan={dataSource.columns.length}
                    style={{ padding: 0, border: 0 }}
                  >
                    <Collapse
                      in
                      transitionDuration={0}
                      style={{ margin: 0, padding: 0 }}
                    >
                      {item.collapse}
                    </Collapse>
                  </td>
                </tr>
              )}
            </>
          ))}
        </tbody>
      </Table>
    </ScrollArea>
  );
};

export default memo(TableComponent);
